import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import main from '@/components/public/main'
import foot from '@/components/public/foot'
import zxxy from '@/components/zxxy'
import tmbz from '@/components/tmbz'
import pxcx from '@/components/pxcx'
import hjqy from '@/components/hjqy'
import hjqy_detail from '@/components/hjqy_detail'
import ljhjqy from '@/components/ljhjqy'
import ljhjqy_detail from '@/components/ljhjqy_detail'
import bjlsc from '@/components/bjlsc'
import about from '@/components/about'
import xmtd from '@/components/xmtd'
import jchg from '@/components/jchg'
import jchg_photo from '@/components/jchg_photo'
import jchg_video from '@/components/jchg_video'
import jchgList from '@/components/jchgList'
import tmc from '@/components/tmc'
import zxybg from '@/components/zxybg'
import report from '@/components/report'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/report',
      name: 'report',
      component:main,
      children:[
        {
          path: 'index',
          name: 'index',
          components: {
            default:report,
            foot:foot
          }
        }
       ]
    },
    {
      path: '/zxxy',
      name: 'zxxy',
      component:main,
      children:[
        {
          path: 'index',
          name: 'index',
          components: {
            default:zxxy,
            foot:foot
          }
        }
       ]
    },
    {
      path: '/tmbz',
      name: 'tmbz',
      component:main,
      children:[
        {
          path: 'index',
          name: 'index',
          components: {
            default:tmbz,
            foot:foot
          }
        }
       ]
    },
    {
      path: '/pxcx',
      name: 'pxcx',
      component:main,
      children:[
        {
          path: 'index',
          name: 'index',
          components: {
            default:pxcx,
            foot:foot
          }
        }
       ]
    },
    {
      path: '/hjqy',
      name: 'hjqy',
      component:main,
      children:[
        {
          path: 'index',
          name: 'index',
          components: {
            default:hjqy,
            foot:foot
          }
        },
        {
          path: 'detail',
          name: 'detail',
          components: {
            default:hjqy_detail,
            foot:foot
          }
        }
       ]
    },
    {
      path: '/ljhjqy',
      name: 'ljhjqy',
      component:main,
      children:[
        {
          path: 'index',
          name: 'index',
          components: {
            default:ljhjqy,
            foot:foot
          }
        },
        {
          path: 'list/:id',
          name: 'list',
          components: {
            default:ljhjqy_detail,
            foot:foot
          }
        },
        {
          path: 'detail/:id',
          name: 'detail',
          components: {
            default:hjqy_detail,
            foot:foot
          }
        }
       ]
    },
    {
      path: '/bjlsc',
      name: 'bjlsc',
      component:main,
      children:[
        {
          path: 'index',
          name: 'index',
          components: {
            default:bjlsc,
            foot:foot
          }
        }
       ]
    },
    {
      path: '/tmc',
      name: 'tmc',
      component:main,
      children:[
        {
          path: 'index',
          name: 'index',
          components: {
            default:tmc,
            foot:foot
          }
        }
       ]
    },
    {
      path: '/xmtd',
      name: 'xmtd',
      component:main,
      children:[
        {
          path: 'index',
          name: 'index',
          components: {
            default:xmtd,
            foot:foot
          }
        }
       ]
    },
    {
      path: '/about',
      name: 'about',
      component:main,
      children:[
        {
          path: 'index',
          name: 'index',
          components: {
            default:about,
            foot:foot
          }
        }
       ]
    },
    {
      path: '/zxybg',
      name: 'zxybg',
      component:main,
      children:[
        {
          path: 'index',
          name: 'index',
          components: {
            default:zxybg,
            foot:foot
          }
        }
       ]
    },
    {
      path: '/jchg',
      name: 'jchg',
      component:main,
      children:[
        {
          path: 'list/:id?',
          name: 'list',
          components: {
            default:jchg,
            foot:foot
          }
        },
        {
          path: 'index',
          name: 'index',
          components: {
            default:jchgList,
            foot:foot
          }
        },
        {
          path: 'index/photo/:id?',
          name: 'photo',
          components: {
            default:jchg_photo,
            foot:foot
          }
        },
        {
          path: 'index/video/:id?',
          name: 'video',
          components: {
            default:jchg_video,
            foot:foot
          }
        }
       ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js